export default {
  GOOGLE_ANALYTICS_ID: "UA-137273391-1"
};
